import React, { createContext } from 'react'
import CookiesStorageService from '../Services/CookiesStorageService'
import AuthServices from '../Services/Consumers/AuthServices'
import { useKeycloak } from '@react-keycloak/web'
import { FormattedMessage } from 'react-intl'
import Configuration from '../Services/Api/Configuration'
import moment from 'moment'
import Cookies from 'js-cookie'

const AuthContext = createContext({})

const AuthProvider = ({ children }) => {
  const { keycloak, initialized } = useKeycloak()

  const [userDataLoading, setUserDataLoading] = React.useState(false)
  const [userDataFailure, setUserDataFailure] = React.useState(false)
  const [userData, setUserData] = React.useState({})
  const [userPermissions, setUserPermissions] = React.useState([])
  const [taxpayerData, setTaxpayerData] = React.useState({})
  const [isUserActive, setIsUserActive] = React.useState(true)
  const [inactiveUserData, setInactiveUserData] = React.useState({})


  const [taxpayerSubscriptionsLoading, setTaxpayerSubscriptionsLoading] = React.useState(true)
  const [taxpayerSubscriptionsData, setTaxpayerSubscriptionsData] = React.useState({})

  const [menuParents, setMenuParents] = React.useState({})


  const activateMenuParent = (entity, isActive) => {
    setMenuParents(prevState => ({ ...prevState, [entity]: isActive }))
  }

  const getUserData = React.useCallback(() => {
    if (!!keycloak?.authenticated) {
      setUserDataFailure(false)
      setUserDataLoading(true)
      AuthServices.getCurrentUser(<FormattedMessage id='userProfile.FormErrorAlert'/>).then((result) => {
        if ((!!result?.response && result?.response?.status !== 200) || !result) {
          if ((!!result?.response && result?.response?.status === 423)) {
            setIsUserActive(false)
            let user = keycloak?.loadUserInfo()
            user.then((result) => {
              if (!!result) {
                setInactiveUserData(result)
              }
            })
          } else {
            setUserDataFailure(true)
          }
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            if (!!result.data.data?.is_completed) {
              /*Redirect to select company page*/
              if (parseInt(result.data.data?.active_taxpayers || 0) > 1
                && (undefined === Cookies.get('RedirectToSelectCompany') ||
                  (!!Cookies.get('RedirectToSelectCompany') && (keycloak.sessionId.toString() !== Cookies.get('RedirectToSelectCompany').toString())))
              ) {
                Cookies.set('RedirectToSelectCompany', keycloak.sessionId)
                setTimeout(() => {
                  window.location.href = `${Configuration?.PROFILING_URL}/selecttaxpayer?redirect_uri=${document.location.href}&view-current=1`
                }, 50)
              }
              setUserData(result.data.data)
            } else {
              window.location.href = Configuration.PROFILING_URL
            }
          } else {
            setUserDataFailure(true)
          }
        }
      })
      AuthServices.getCurrentTaxpayer(<FormattedMessage id='currentTaxpayer.FormErrorAlert'/>).then((result) => {
        if ((!!result?.response && result?.response?.status !== 200) || !result) {
          setUserDataFailure(true)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            setUserPermissions(result.data.data?.taxpayer_permissions)
            if ((!!result.data.data?.representation_to && moment(result.data.data?.representation_to).diff(moment(), 'days', true) < 0) ||
              !result.data.data?.taxpayer?.status) {
              setIsUserActive(false)
            }
            let taxpayer = result.data.data?.taxpayer
            CookiesStorageService.setTaxpayerTRN(taxpayer?.trn)
            if (taxpayer?.trn) {
              // setTaxpayerSubscriptionsData({ hasValidSubscription: true, hasQuota:true })
              // setTaxpayerSubscriptionsLoading(false)
              AuthServices.getCurrentTaxpayerSubscriptions(taxpayer?.trn, { params: { serviceId: 'e-invoicing' } },
                <FormattedMessage id='currentTaxpayerSubscriptions.FormErrorAlert'/>).then((subscriptionResult) => {
                if (!!subscriptionResult && !!subscriptionResult.data && !!subscriptionResult.data.data) {
                  setTaxpayerSubscriptionsData({
                    ...subscriptionResult.data.data,
                    hasValidSubscription: !!subscriptionResult.data.data?.subscribed,
                    hasQuota: (parseInt(subscriptionResult.data.data?.totalUsage || 0) < parseInt(subscriptionResult.data.data?.totalQuota || 0))
                  })
                }
              }).then(() => {
                setTaxpayerSubscriptionsLoading(false)
              })
            } else {
              setTaxpayerSubscriptionsLoading(false)
            }
            taxpayer.branches = result.data.data?.branch_access_type?.toString() === 'all' ? result.data.data?.taxpayer?.branches : result.data.data?.taxpayer?.branches.filter(branch => result.data.data?.branches?.includes(branch?.branch_number))
            setTaxpayerData(taxpayer)
          } else {
            setUserDataFailure(true)
            setTaxpayerSubscriptionsLoading(false)
          }
        }
      }).then(() => {
        setTimeout(() => setUserDataLoading(false), 200)
      })
    }
  }, [keycloak])


  React.useEffect(() => {
    // eslint-disable-next-line
    if (!!initialized) {
      getUserData()
    }
  }, [initialized, getUserData])

  React.useEffect(() => {
    CookiesStorageService.clearTaxpayerTRN()
    return CookiesStorageService.clearTaxpayerTRN()
    // eslint-disable-next-line
  }, [])
  return (
    <AuthContext.Provider value={{
      userDataLoading,
      userDataFailure,

      userData,
      userPermissions,
      taxpayerData,
      isUserActive,

      inactiveUserData,

      taxpayerSubscriptionsLoading,
      taxpayerSubscriptionsData,

      menuParents,
      activateMenuParent
    }}>
      {children}
    </AuthContext.Provider>
  )
}
const AuthConsumer = AuthContext.Consumer

export { AuthProvider, AuthConsumer, AuthContext }
